import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Modal from 'react-responsive-modal';
import Select from 'react-dropdown-select';
import {withRouter} from 'react-router-dom'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import {getComapreProductDetail} from '../../../../actions/productCompare'

import { hover, unhover, sizeChartDefault } from '../../../common/MangoIcons';
import FullPageLoader from '../../../../components/common/fullPageLoader';
import SmallImages from '../../common/product/small-image';
import noProductImage  from '../../../../assets/images/noProductImg_420x420.jpg'


class DetailsWithPrice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            quantity: 1,
            colorSelected: props.colorSelected,
            sizeSelected:  props.sizeSelected,
            puritySelected: props.puritySelected,
            count: 0,
        }
    }

    onOpenSizeModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentDidMount() {   
        
    }

    componentWillReceiveProps() {
        const { colorSelected, presentURL } =  this.props;
            this.setState({
                colorSelected: colorSelected
            })
    }

    handlePopup = (pc) => {

        const myArrayFromLocalStorage = localStorage.getItem('myArray')
if (myArrayFromLocalStorage && myArrayFromLocalStorage.length) {
const myArray = JSON.parse(myArrayFromLocalStorage)
myArray.indexOf(pc) === -1 && myArray.push(pc)
localStorage.setItem('myArray', JSON.stringify(myArray))


}
else {
    const myArray = [pc]
    localStorage.setItem('myArray', JSON.stringify(myArray))
}   

       

     var  myArray   = localStorage.getItem('myArray');
     const product_codes = JSON.parse(myArray)

        const options = {
            connection_id : this.props.connection_id,
            product_code : product_codes
        }
      
        this.props.getComapreProductDetail(options) 
        this.setState({ open: true });
   
    };
    removeCompare=(pc)=>{
        document.getElementById(pc).remove();
        var  myArray   = localStorage.getItem('myArray');

     const product_codes = JSON.parse(myArray)
    
     for( var i = 0; i < product_codes.length; i++){ 
     
         if ( product_codes[i] === pc) { 
     
             product_codes.splice(i, 1); 
         }
     
     }


localStorage.setItem('myArray', JSON.stringify(product_codes))


    }


    componentDidUpdate(){
        const { colorSelected, presentURL } =  this.props;
        if(this.state.count <= 1){
        this.setState({
            colorSelected: colorSelected,
            count: this.state.count + 1,
        })
        }
    }

    // componentDidUpdate(prevProps, prevState){
    //     const {item} = this.props  
    //     if(this.setState !== prevState){
    //         this.setState({
    //             colorSelected:  item.SKU_VARIANT1_VALCD,
    //             sizeSelected:  item.SKU_VARIANT2_VALCD,
    //             sizeSelectedName:  item.SKU_VARIANT2_VALUE_DESC
    //         });
    //     }
    // }

    minusQty = () => {
        if (this.state.quantity > 1) {
            this.setState({ stock: 'InStock' })
            this.setState({ quantity: this.state.quantity - 1 })
        }
    }

    plusQty = () => {
        if (parseInt(this.props.item.QOL_FREE_QOH) > this.state.quantity) {
            this.setState({ quantity: this.state.quantity + 1 })
        } else {
            this.setState({ stock: 'Out of Stock !' })
        }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }

    variantStyle = (color) => {
        if (color && color === '#FFF' || color === '#FFFFFF' || color === 'White' || color === 'WHITE' || color === 'white')
            return ({ backgroundColor: color, border: '1px solid #777', width: 25, height: 25 })
        else
            return ({ backgroundColor: color, width: 25, height: 25 })
    }

    onClickHandle(img) {
        this.setState({ image: img });
    }

    handleColorChange = (value) => {
       // event.preventDefault();
        if (value.length > 0){
            const trimmed = value.map(v => ({
    ...v,
    SKU_VARIANT1_VALUE_DESC: v.SKU_VARIANT1_VALUE_DESC.slice(0, 10) + "..."
  }));
  console.log("trimmed", trimmed)
            
        this.setState({
            colorSelected: trimmed,
            sizeSelected: [],
            puritySelected:[]
        })
        const options = {
            connection_id: this.props.connection_id,
            // lot_code: this.props.lot_code,
            color_id: value[0].SKU_VARIANT1_VALCD,
            color_desc: trimmed[0].SKU_VARIANT1_VALUE_DESC,
            product_id: this.props.item.SKF_PRODUCT_GROUP_CD,
            sizeReset: true,
            tenant_name: this.props.store_details && this.props.store_details.tenant_name
        }
        const options1 ={
            connection_id: this.props.connection_id,
             lot_code: this.props.lot_code,
            tenant_name: this.props.store_details && this.props.store_details.tenant_name

        }

            this.props.handleProductUpdate(options,options1);
        }
    }

    handleSizeChange = (value) => {
       
        this.setState({
            puritySelected:[],
            purityReset:true
        })
        if (value.length > 0){
        
        const options = {
            connection_id: this.props.connection_id,
            // lot_code: this.props.lot_code,
            size_id: value[0].SKU_VARIANT2_VALCD,
            size_desc : value[0].SKU_VARIANT2_VALUE_DESC,
            color_id: this.state.colorSelected[0].SKU_VARIANT1_VALCD,
            product_id: this.props.item.SKF_PRODUCT_GROUP_CD,
            tenant_name: this.props.store_details && this.props.store_details.tenant_name

        }
        const options1 ={
            connection_id: this.props.connection_id,
             lot_code: this.props.lot_code,
            tenant_name: this.props.store_details && this.props.store_details.tenant_name

        }
        this.props.handleProductUpdate(options,options1);
        }
    }

    handlePurityChange = (value) => {
        
        if (value.length > 0){
        
        const options = {
            connection_id: this.props.connection_id,
            // lot_code: this.props.lot_code,
            purity_id: value[0].SKU_VARIANT4_VALCD,
            purity_desc : value[0].SKU_VARIANT4_VALUE_DESC,
            size_id:this.state.sizeSelected[0].SKU_VARIANT2_VALCD,
            size_desc:this.state.sizeSelected[0].SKU_VARIANT2_VALUE_DESC,

            color_id: this.state.colorSelected[0].SKU_VARIANT1_VALCD,
            product_id: this.props.item.SKF_PRODUCT_GROUP_CD
        }
        const options1 ={
            connection_id: this.props.connection_id,
             lot_code: this.props.lot_code
        }
        this.props.handleProductUpdate(options,options1);
        }
    }
    handleEnquiry =() => {
        this.props.history.push('/enquiry')
    }

    // formatTitle = (text) => {
    //     return typeof (text) == 'string' && text[0].toUpperCase() + text.slice(1)
    // }
    mobileCompare = (pc) => {
        const myArrayFromLocalStorage = localStorage.getItem('myArray')
if (myArrayFromLocalStorage && myArrayFromLocalStorage.length) {
const myArray = JSON.parse(myArrayFromLocalStorage)
myArray.indexOf(pc) === -1 && myArray.push(pc)
localStorage.setItem('myArray', JSON.stringify(myArray))


}
else {
    const myArray = [pc]
    localStorage.setItem('myArray', JSON.stringify(myArray))
}
        

        

     var  myArray   = localStorage.getItem('myArray');
     const product_codes = JSON.parse(myArray)

        const options = {
            connection_id : this.props.connection_id,
            product_code : product_codes
        }
      
        this.props.getComapreProductDetail(options) 
        window.open('./compare');
   
     
       
      };



    render() {
        const {productAdditionalInfo, compareDetail,symbol,dat, item,pshop_soh_display, itemVariants, addToCartClicked, addToWishlistClicked, BuynowClicked, allProductImages,productsnav, nav1, productImages, productLoadingData, presentURL,store_details } = this.props
   
     let ReactDropdownStyle ;
     store_details && store_details.tenant_name == 'Goldiam International Limited' 
?
     ReactDropdownStyle = {
        width:'140px' 
    }
    :ReactDropdownStyle ={}
        var offers = '';
     productAdditionalInfo.map((information,index)=>{
    if(information.PSH_ATT_DESC === 'Available Offers'){
        offers = information.PSD_ATT_VALUE_DESC.replace('<br/>', '\r\n') 
    }
     })
        return (
            <div className={dat === null ? "col-lg-6 rtl-text" : "col-lg-5 rtl-text"}>
                    <div className="product-right" style={{ marginTop: 30, marginLeft: 30 }}>
                    {/* Product Title, Price, Category description section */}
                    <h6 style={{ fontSize: 14, textAlign: "left" , margin: "0"}}> {item.SKU_HNODE_DESC} </h6>
                    <div style={{ display: "flex", alignItems: "stretch" }}>
                        <h2 style={{ fontSize: 20, flexGrow: 8, textAlign: "left" }}>{item.PRODUCT_SHORT_DESC} </h2>
                        <div style={{ flexGrow: 2 }}>
                            {/* {(item.QOL_PRICE > item.QOL_SELLING_PRICE) ?
                                <h4 style={{ textAlign: "right" }}>
                                    {(item.QOL_PRICE > item.QOL_SELLING_PRICE) ? <del>{symbol}  {item.QOL_PRICE}</del> : ''}
                                     <span>{item.QOL_PRICE}% off</span> 
                                </h4> : null} */}
                            <h2 style={{ fontSize: 20, textAlign: "right" }}>{symbol}  {item.QOL_PRICE} </h2>
                        </div>
                    </div>
                    <h6 style={{ fontSize: 14, textAlign: "left" }}> {item.SKU_PRODUCT_CD} </h6>
                    {/* <h6 style={{ fontSize: 12, textAlign: "left", marginBottom: 0 }}> {item.SKU_PRODUCT_CD} </h6> */}

                    {/* Product Color Variant Section.. */}
                    {/* {itemVariants && itemVariants[0] && itemVariants[0].PDM_VARIANT_DETAIL.length > 1 ?
                        <ul >
                            <div className="color-variant">
                                {itemVariants[0].PDM_VARIANT_DETAIL.map((variant_color, i) => {
                                    return <li className={this.state.colorSelected === variant_color.SKU_VARIANT_VALCD ? 'active' : ''}
                                        style={variant_color.SKU_VARIANT_HEXCODE ? this.variantStyle(variant_color.SKU_VARIANT_HEXCODE) : this.variantStyle('#000')}
                                        key={i}
                                        onClick={(event) => this.handleColorChange(variant_color, event)}
                                        title={variant_color.SKU_VARIANT_VALUE_DESC}>
                                    </li>
                                })}
                            </div>
                        </ul> : ''} */}

                    {/* Product Size Variant, Quantity, size chart Section.. */}
                    <div className="product-description border-product" style={{ border: "none",paddingTop:0 }}>
                       {window.innerWidth > 767 ? 
                        <div>
                            {/* {item.MHM_SIZECHART ? */}
                            {/* <>
                                    <h6 className="product-title size-text">select size
                                    <span
                                            data-toggle="modal"
                                            data-target="#sizeChartmodal"
                                            style={{ cursor: "pointer", color: "#007bff" }}
                                            onClick={this.onOpenSizeModal}>size chart</span>
                                    </h6>
                                </> */}
                            {/* : ''} */}
                            <div  className='row product-select' style={{padding:'0 0 0 15px'}}>
                            {itemVariants && itemVariants[0] ?
                                // <div className="color-variant">
                                <div className="size-box">
                                    <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                            Color
                                        </div><br/><br/>
                                    <div className=" col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <Select
                                           // disabled={itemVariants[0].PDM_VARIANT_DETAIL.length < 2 ? true : false}
                                            searchable={false}
                                            label="colore"
                                            labelField='SKU_VARIANT1_VALUE_DESC'
                                            valueField='SKU_VARIANT1_VALCD'
                                            keepSelectedInList={false}
                                            options={itemVariants}
                                            // placeholder={this.props.item.SKU_VARIANT2_VALUE_DESC}
                                            values={this.state.colorSelected}
                                            onChange={this.handleColorChange}
                                            className={"reactDropdownStyle"}
                                             style={ReactDropdownStyle}
                                        />

                                    </div>
                                </div>
                                // </div>
                                : ''}
                                &nbsp;
                                &nbsp;
                            {itemVariants &&  itemVariants[0]  ?
                                <div>
                                    {/* <h6 className="product-title">Sizes</h6> */}
                                    <div className="size-box">
                                    <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                            Size
                                        </div>
                                        <br /><br/>
                                        <div className=" col-sm-12" style={{ paddingLeft: 0, paddingRight: 0 }}>

                                            {/* <select name="size" value={this.state.sizeSelected} onChange={this.handleSizeChange}>
                                                    {itemVariants[1].PDM_VARIANT_DETAIL.map((size, i) => {
                                                     return <option> {size.SKU_VARIANT_VALUE_DESC}</option>
                                                     })}
                                                </select> */}
                                            <Select
                                                searchable={false}
                                                labelField='SKU_VARIANT2_VALUE_DESC'
                                                valueField='SKU_VARIANT2_VALCD'
                                                keepSelectedInList={false}
                                                options={this.state.colorSelected.length > 0 && this.state.colorSelected[0].variant_size_details}
                                                dropdownGap={5}
                                                placeholder={"Select your size"}
                                                
                                                // values={[{
                                                //     SKU_VARIANT_VALCD: this.props.item.SKU_VARIANT2_VALCD,
                                                //     SKU_VARIANT_VALUE_DESC: this.props.item.SKU_VARIANT2_VALUE_DESC
                                                // }]}
                                                values={this.state.sizeSelected}
                                                onChange={this.handleSizeChange}
                                                className={"reactDropdownStyle"}
                                          style={ReactDropdownStyle}

                                            />

                                        </div>
                                    </div>
                                </div> : ''}
                                &nbsp;
                                &nbsp;
                                                              
                            {store_details && store_details.tenant_name == 'Goldiam International Limited' && itemVariants &&  itemVariants[0]  ?
                                <div>
                                    {/* <h6 className="product-title">Sizes</h6> */}
                                    <div className="size-box">
                                    <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                            Purity
                                        </div>
                                        <br /><br/>
                                        <div className=" col-sm-12" style={{ paddingLeft: 0, paddingRight: 0 }}>

                                            {/* <select name="size" value={this.state.sizeSelected} onChange={this.handleSizeChange}>
                                                    {itemVariants[1].PDM_VARIANT_DETAIL.map((size, i) => {
                                                     return <option> {size.SKU_VARIANT_VALUE_DESC}</option>
                                                     })}
                                                </select> */}
                                            <Select
                                                searchable={false}
                                                labelField='SKU_VARIANT4_VALUE_DESC'
                                                valueField='SKU_VARIANT4_VALCD'
                                                keepSelectedInList={false}
                                                options={this.state.colorSelected.length > 0 && this.state.colorSelected[0].variant_size_details && this.state.colorSelected[0].variant_size_details[0].variant_purity_details}
                                                dropdownGap={5}
                                                placeholder={"Select your purity"}
                                                
                                                // values={[{
                                                //     SKU_VARIANT_VALCD: this.props.item.SKU_VARIANT2_VALCD,
                                                //     SKU_VARIANT_VALUE_DESC: this.props.item.SKU_VARIANT2_VALUE_DESC
                                                // }]}
                                                values={this.state.puritySelected}
                                                onChange={this.handlePurityChange}
                                                className={"reactDropdownStyle"}
                                          style={ReactDropdownStyle}

                                            />

                                        </div>
                                    </div>
                                </div> : ''}
                                </div>
                        </div> : 
                         <div>
                         {/* {item.MHM_SIZECHART ? */}
                         {/* <>
                                 <h6 className="product-title size-text">select size
                                 <span
                                         data-toggle="modal"
                                         data-target="#sizeChartmodal"
                                         style={{ cursor: "pointer", color: "#007bff" }}
                                         onClick={this.onOpenSizeModal}>size chart</span>
                                 </h6>
                             </> */}
                         {/* : ''} */}
                         <div  className='product-select' style={{padding:'0 0 0 15px'}}>
                         {itemVariants && itemVariants[0] ?
                             // <div className="color-variant">
                             <div className="size-box row">
                                 <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                         Color
                                     </div><br/><br/>
                                 <div className=" col-sm-12   col-xs-12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                     <Select
                                        // disabled={itemVariants[0].PDM_VARIANT_DETAIL.length < 2 ? true : false}
                                         searchable={false}
                                         label="colore"
                                         labelField='SKU_VARIANT1_VALUE_DESC'
                                         valueField='SKU_VARIANT1_VALCD'
                                         keepSelectedInList={false}
                                         options={itemVariants}
                                         // placeholder={this.props.item.SKU_VARIANT2_VALUE_DESC}
                                         values={this.state.colorSelected}
                                         onChange={this.handleColorChange}
                                         className={"reactDropdownStyle"}
                                          style={ReactDropdownStyle}
                                     />

                                 </div>
                             </div>
                             // </div>
                             : ''}
                            
                         {itemVariants &&  itemVariants[0]  ?
                             <div>
                                 {/* <h6 className="product-title">Sizes</h6> */}
                                 <div className="size-box row">
                                 <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                         Size
                                     </div>
                                     <br /><br/>
                                     <div className=" col-sm-12" style={{ paddingLeft: 0, paddingRight: 0 }}>

                                         {/* <select name="size" value={this.state.sizeSelected} onChange={this.handleSizeChange}>
                                                 {itemVariants[1].PDM_VARIANT_DETAIL.map((size, i) => {
                                                  return <option> {size.SKU_VARIANT_VALUE_DESC}</option>
                                                  })}
                                             </select> */}
                                         <Select
                                             searchable={false}
                                             labelField='SKU_VARIANT2_VALUE_DESC'
                                             valueField='SKU_VARIANT2_VALCD'
                                             keepSelectedInList={false}
                                             options={this.state.colorSelected.length > 0 && this.state.colorSelected[0].variant_size_details}
                                             dropdownGap={5}
                                             placeholder={"Select your size"}
                                             
                                             // values={[{
                                             //     SKU_VARIANT_VALCD: this.props.item.SKU_VARIANT2_VALCD,
                                             //     SKU_VARIANT_VALUE_DESC: this.props.item.SKU_VARIANT2_VALUE_DESC
                                             // }]}
                                             values={this.state.sizeSelected}
                                             onChange={this.handleSizeChange}
                                             className={"reactDropdownStyle"}
                                          style={ReactDropdownStyle}

                                         />

                                     </div>
                                 </div>
                             </div> : ''}

                             {store_details && store_details.tenant_name == 'Goldiam International Limited' && itemVariants &&  itemVariants[0]  ?
                             <div>
                                 {/* <h6 className="product-title">Sizes</h6> */}
                                 <div className="size-box row">
                                 <div className="col-md-1 col-sm-1   col-xs-1" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left" }}>
                                         Purity
                                     </div>
                                     <br /><br/>
                                     <div className=" col-sm-12" style={{ paddingLeft: 0, paddingRight: 0 }}>

                                         {/* <select name="size" value={this.state.sizeSelected} onChange={this.handleSizeChange}>
                                                 {itemVariants[1].PDM_VARIANT_DETAIL.map((size, i) => {
                                                  return <option> {size.SKU_VARIANT_VALUE_DESC}</option>
                                                  })}
                                             </select> */}
                                         <Select
                                             searchable={false}
                                             labelField='SKU_VARIANT4_VALUE_DESC'
                                             valueField='SKU_VARIANT4_VALCD'
                                             keepSelectedInList={false}
                                             options={this.state.colorSelected.length > 0 && this.state.colorSelected[0].variant_size_details}
                                             dropdownGap={5}
                                             placeholder={"Select your purity"}
                                             
                                             // values={[{
                                             //     SKU_VARIANT_VALCD: this.props.item.SKU_VARIANT2_VALCD,
                                             //     SKU_VARIANT_VALUE_DESC: this.props.item.SKU_VARIANT2_VALUE_DESC
                                             // }]}
                                             values={this.state.puritySelected}
                                             onChange={this.handlePurityChange}
                                             className={"reactDropdownStyle"}
                                          style={ReactDropdownStyle}

                                         />

                                     </div>
                                 </div>
                             </div> : ''}
                             </div>
                     </div>}
                        <div className='row ' style={{marginTop:10}} >
                            <div className='col-6'>
                            <div style={{ flexGrow: 1, textAlign: "left" }}>
                                <h6 className="product-title" style={{ fontSize: 12 }}>quantity</h6>
                            </div>

                            <div style={{ flexGrow: 8 }}>
                                <div className="qty-box" style={{ justifyContent: "flex-start" }}>
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                                <i className="fa fa-angle-left"></i>
                                            </button>
                                        </span>
                                        <input type="text" disabled name="quantity" style={{ borderTop: "1px solid #ced4da" }} value={this.state.quantity} onChange={this.changeQty} className="form-control input-number" />
                                        <span className="input-group-prepend">
                                            <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                                <i className="fa fa-angle-right"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                                </div> 

                                <div className='col-6'><br/><br/>
                                {pshop_soh_display === 'Y' && this.state.sizeSelected.length > 0 && this.state.puritySelected.length > 0 ? 
                        <div style={{fontWeight: 700,color:'black',textAlignLast:'left'}}>
                        <span className="">{ item.QOL_FREE_QOH === '0.000'  ? 
                        store_details && store_details.tenant_name != 'Goldiam International Limited'  ? 'Out of Stock !' : 'Continue with MTO' : parseInt(item.QOL_FREE_QOH)+' In Stock'}</span>
                        </div> : ''}
                                    </div></div>
                                    {/* {item.MHM_SIZECHART ?
                        <div style={{ display: "flex", alignItems: "stretch", marginTop: 25 }}>
                            
                            <div style={{ flexGrow: 1, marginTop: 14, textAlign: "right" }}>
                                
                                    
                                        <img src={sizeChartDefault} className="icon-hovers" />
                                        <span
                                            data-toggle="modal"
                                            data-target="#sizeChartmodal"
                                            style={{ cursor: "pointer", color: "#000", textAlign: "right", fontSize: 12, fontWeight: 600, "&:hover": { background: "#777" } }}
                                            onClick={this.onOpenSizeModal}>Size Chart</span>

                                   
                                    
                            </div>
                        </div>: ''} */}
                        {/* <h6 className="product-title">quantity</h6>
                        <div className="qty-box">
                            <div className="input-group">
                                <span className="input-group-prepend">
                                    <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                        <i className="fa fa-angle-left"></i>
                                    </button>
                                </span>
                                <input type="text" name="quantity" value={this.state.quantity} onChange={this.changeQty} className="form-control input-number" />
                                <span className="input-group-prepend">
                                    <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                        <i className="fa fa-angle-right"></i>
                                    </button>
                                </span>
                            </div>
                        </div> */}
                    </div>

                    {/* Product Buttons section... */}
                    <div className="product-buttons" style={{ marginTop: 20 }}>
                        <div style={{ display: "flex", alignItems: "stretch" }}>
                            <button className="btn btn-solid" style={{ marginRight: 8, flexGrow: 9, backgroundSize: 1188 }} onClick={() => addToCartClicked(item, this.state.quantity)} disabled={item.QOL_FREE_QOH === '0.000' && this.state.sizeSelected.length > 0 && this.state.puritySelected.length > 0 && store_details && store_details.tenant_name != 'Goldiam International Limited'   ? 'true' : ''}>add to cart</button>
                          
                        </div>


                        {/* <a href="javascript:void(0)" title="Add to Wishlist" onClick={() => addToWishlistClicked(item)}>
                            <i className="fa fa-heart" aria-hidden="true"></i>
                        </a> */}
                    </div>

                    {/* Product Description Section.. */}
                    

                    {/* Share It links */}
              {/*       <div class="product-share">
                <span class="share-title">Share It </span>
            <ul class="menu-social-icons ">
        
                    <li  className='ull'>
                        
                            <a className='lk lnk' href="#"></a>
                     
                    </li>
            
                    <li className='ull'>
                    <a className='lnk1 lk' href="#"></a>
                       
                    </li>
            
                    <li className='ull'>
                    <a className='lnk2 lk' href="#"></a>
                    </li>
            
                    <li className='ull'>
                    <a className='lnk3 lk' href="#"></a>

                    </li>
            
            </ul>
                    </div> */}
                    {offers !== '' ? 
                    <div class="prod-avb-offers">
<span class="prod-avb-title">Available Offers</span>
<div class="clearfix"></div>
<div>
    <div style={{whiteSpace: 'pre-wrap'}}>{offers}</div>
{/* <p><b>Cashback Offer:</b><br/>
<b>Full Swipe:</b><span class="apple-converted-space">&nbsp;</span>Cashback of ₹4000 on HDFC Bank Credit card.<br/>
<b>No Cost EMI:</b><span class="apple-converted-space">&nbsp;</span>Cashback of ₹4000 on HDFC Bank Credit &amp; Debit Card with 6 months of No Cost EMI.</p>
</div>
<div>
<p><b>EMI Offer:</b><span class="apple-converted-space">&nbsp;</span>*Consumer loans *Zest Money *HDFC Bank *Bajaj Finance * IDFC FIRST *Zest *TVS</p>
</div>
<div>
<p><b>Get free 30 days access to Lionsgate Play with your purchase</b></p>
</div>
<div>
<p>Note: To avail Cashback, please select<span class="apple-converted-space">&nbsp;</span><b>Edge by PineLabs</b><span class="apple-converted-space">&nbsp;</span>as the Payment method on checkout page. Orders placed through this mode cannot be cancelled or refunded.<br/>
Cashback will be credited to your account within 120 days by the bank from the date of purchase.</p> */}
</div>
</div> : '' }
                    {/* <div className='row' style={{padding:15}}>
                        <div className='col'>
                            <button className='btn btn-solid' onClick={()=>this.handleEnquiry()}>Enquire Now</button>
                        </div>
                        <div className='col'>
                            <button className='btn btn-solid' onClick={window.innerWidth > 567 ? () =>this.handlePopup(item.SKU_PRODUCT_CD) : () =>this.mobileCompare( item.SKU_PRODUCT_CD)}>Compare</button>

                        </div>
                        
                    </div>         */}




                </div>
                <Modal open={this.state.open} onClose={this.onCloseModal} center classNames={{modal: 'sizeChartModal'}}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{item.SKU_PRODUCT_DETAIL_DESC}</h5>
                            </div>
                            <div className="modal-body">
                                {/* <img src={`${item.MHM_SIZECHART}`} alt="" className="img-fluid" /> */}
                                <img src='https://multikart-react.vercel.app/_next/static/images/size-chart-27d5967a8cdfebf70b190ed5c6dd9bac.jpg' alt="" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal open={this.state.open} onClose={this.onCloseModal} center>           
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content quick-view-modal">
                            <div className="modal-body">
                               
                                                               <table style={{width:'max-content'}}>
                                                                 
                                                               <tbody style={{    textAlign: 'center'}}> 
                                                               <tr>
                                                               <td>
                                                                           &nbsp;
                                                                       </td>
                                                                       <td style={{padding:30}}>
                                                                           Title
                                                                       </td>
                                                                       <td style={{height:130}}>
                                                                       Image
                                                                       </td>
                                                                       
                                                                       <td style={{paddingTop:40}}>
                                                                           Brand
                                                                       </td>
                                                                       <td>Price
                                                                           
                                                                       </td><td>Details

                                                                       </td>
                                                                      
                                                                       <td style={{paddingTop:20}}>
                                                                           Product Code
                                                                       </td>
                                                                       <td>
                                                                       Description
                                                                           
                                                                        </td>

                                                               </tr>
                                    {compareDetail.map((productCompare,index) =>{
                                return(     <tr  role='row' id={productCompare.SKU_PRODUCT_CD} >
<td onClick={()=>this.removeCompare(productCompare.SKU_PRODUCT_CD)} style={{cursor:'pointer'}}>Remove</td>

                                        
                                        

                                            <td style={{padding:30}}>{productCompare.SKU_DESC}</td>
                                            <td  >
                                            {productCompare.SKF_IMAGE && productCompare.SKF_IMAGE.length > 50 && productCompare.SKF_IMAGE !== '\/images\/noProductImg_45x45.jpg' ? 
                                            
                                        <img  style={{width:123}}
                                                src={productCompare.SKF_IMAGE}
                                                alt="" className="img-fluid" /> :
                                                <img  style={{width:123}}
                                                src={noProductImage}
                                                alt="" className="img-fluid" /> }

                                
                                </td>
                                <td >{productCompare.SKU_BRD_DESC}</td>
                                <td>{productCompare.MAX_PRICE}</td>
                                <td>{productCompare.SKU_PRODUCT_DETAIL_DESC}</td>

                                
                                    
                                  <td>
                                      {productCompare.SKF_PRODUCT_GROUP_CD}
                                  </td>
                                    <td style={{width:400}}>{productCompare.SKF_PRODUCT_GROUP_DESC}</td>
                                    </tr>
                                    
                                   
                                   )
                                })

                            }
                             </tbody>
                                
                                </table> 
                            
                            </div>
                        </div>
                    </div>
                     
                </Modal>
                <div>                    
                </div>               
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    compareDetail : state.productCompare.compareDetail,
    store_details: state.tenant.store_details,

})

const mapDispatchToProps = dispatch => bindActionCreators({
    getComapreProductDetail,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DetailsWithPrice));


